export default {
  BASE_URL: process.env.VUE_APP_API_URL,
  NEW_ORG_URL: process.env.VUE_APP_API_URL_NEW_ORG,
  APPROVAL_ENABLED:
    process.env.VUE_APP_ACCOUNT_APPROVAL_ENABLED.valueOf().toString() ===
    "true",
};
